import { configureStore } from "@reduxjs/toolkit";
import { authReducer } from "../core/auth/store/auth.slice";
import { themeReducer } from "./themeSlice";
import { FEATURE_REDUCERS } from "../config/app.config";

export * from "../core/auth/store/auth.slice";
export * from "./themeSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    theme: themeReducer,
    ...FEATURE_REDUCERS,
  },
});
